<template>
  <Card border rounded class="overflow-hidden">
    <Flex justify-between items-center class="h-8 border-b">
      <IconInput icon="fa-chevron-left" class="border-r" @click="prevDecade" />
      <span class="font-semibold">{{ startDecade }} - {{ endDecade }}</span>
      <IconInput icon="fa-chevron-right" class="border-l" @click="nextDecade" />
    </Flex>

    <div class="grid grid-cols-3" v-if="props.range">
      <div
        v-for="year in years"
        :key="year"
        class="text-sm hover:bg-arter-cinza-2 p-1 text-center cursor-pointer"
        @click="selectYearRange(year)"
        :class="{
          'bg-arter-cinza-1 rounded': selectedYears.includes(year),
        }"
      >
        {{ year }}
      </div>
    </div>
    <div class="grid grid-cols-3" v-else>
      <div
        v-for="year in years"
        :key="year"
        class="text-sm hover:bg-arter-cinza-2 p-1 text-center cursor-pointer"
        @click="selectYear(year)"
        :class="{ 'bg-arter-cinza-3 text-white rounded': isSelected(year) }"
      >
        {{ year }}
      </div>
    </div>
  </Card>
</template>

<script setup>
import { ref, computed } from 'vue'

const props = defineProps({
  modelValue: String, // formato: 'YYYY'
  range: Boolean,
})
const emits = defineEmits(['update:modelValue'])

const currentYear = new Date().getFullYear()
const decadeStart = ref(currentYear - 10)

const startYear = ref(null)
const endYear = ref(null)

const selectedYears = computed(() => {
  if (startYear.value === null) {
    return []
  }
  if (endYear.value === null) {
    return [startYear.value]
  }

  const years = []
  const start = Math.min(startYear.value, endYear.value)
  const end = Math.max(startYear.value, endYear.value)
  for (let y = start; y <= end; y++) {
    years.push(y)
  }
  return years
})

const years = computed(() => {
  const yearList = []
  for (let i = 0; i < 12; i++) {
    yearList.push(decadeStart.value + i)
  }
  return yearList
})

const startDecade = computed(() => decadeStart.value)
const endDecade = computed(() => decadeStart.value + 11)

const prevDecade = () => {
  decadeStart.value -= 12
  if (props.range) {
    clearRange()
  }
}

const nextDecade = () => {
  decadeStart.value += 12
  if (props.range) {
    clearRange()
  }
}

const selectYear = (year) => {
  emits('update:modelValue', String(year))
}

const selectYearRange = (year) => {
  if (startYear.value === null) {
    startYear.value = year
    return
  }

  if (endYear.value === null) {
    if (year < startYear.value) {
      endYear.value = startYear.value
      startYear.value = year
    } else {
      endYear.value = year
    }

    const start = Math.min(startYear.value, endYear.value)
    const end = Math.max(startYear.value, endYear.value)
    emits('update:modelValue', `${start}-${end}`)
    return
  }

  clearRange()
  startYear.value = year
}

const isSelected = (year) => {
  if (!props.modelValue) return false
  return Number(props.modelValue) === year
}

const clearRange = () => {
  startYear.value = null
  endYear.value = null
}
</script>